<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage :key="$route.path" />
    </NuxtLayout>
  </div>
</template>
